BS.DOMReady(function() {
	"use strict";

	var DOM = BS.DOM;

	var selectSw = DOM.q(".p-nav-sw-select");
	if (!selectSw) {
		return;
	}

	selectSw.addEventListener("change", function() {
		var selector = selectSw.value,
		target,
		top;
		if (!/^#[0-9A-Za-z_-]+$/.test(selector)) {
			return;
		}
		target = DOM.q(selector);
		if (!target) {
			return;
		}
		top = target.offsetTop;
		if (typeof top !== "undefined") {
			top -= 50;
			if (top < 0) top = 0;
			BS.Scroll.toPosition(top);
		}
	});

	ScrollSwitch.register("y", function() {
		var points = [];

		[].forEach.call(DOM.qs(".customer-area"), function(area) {
			points.push({
				name: "#" + area.id,
				y: area.offsetTop - 51,
			});
		});

		return points;

	}, function(point) {
		var index = null;
		
		point = point || "";

		[].forEach.call(DOM.qs("option", selectSw), function(option, i) {
			if (option.value === point) {
				index = i;
			}
		});

		if (index !== null) {
			selectSw.selectedIndex = index;
		}
	});

	ScrollSwitch.start();
});
